import React, { useRef } from "react";
import { ModuleSection } from "./Parts";
import PropTypes from "prop-types";

import { gsap } from "../../../gsap";
import { useGSAP } from "../../../gsap/react";

const Overlay = ({ backgroundImg, children }) => {
  const panTl = useRef();

  useGSAP(() => {
    panTl.current = gsap
      .timeline({
        scrollTrigger: {
          start: "top center",
          trigger: "#portal-overlay"
          // markers: true
        },
        repeat: -1,
        yoyo: true
      })
      .set("#div-overlay", { backgroundPosition: "80% 50%", scale: 1 })
      .to("#div-overlay", { backgroundPosition: "20% 50%", duration: 10 }, "<");
  }, {});

  return (
    <ModuleSection>
      <div
        id="portal-overlay"
        className="flex flex-col lg:flex-none lg:flex-row relative w-full h-full lg:flex justify-end lg:justify-start"
      >
        <div
          id="div-overlay"
          className="lg:absolute h-[50%] md:h-full w-full bg-right-bottom"
          style={{ backgroundImage: "url(" + backgroundImg + ")", backgroundSize: "auto 100%" }}
        />

        <div className="z-10 w-full flex-grow lg:flex-none lg:w-[33%] pb-3 lg:pb-0 h-auto md:flex bg-white lg:bg-white/90 items-center justify-center">
          <div className="text-center text-dark-blue px-[30px] h-full lg:h-auto flex items-center">
            {children}
          </div>
        </div>
      </div>
    </ModuleSection>
  );
};

Overlay.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export default Overlay;
